import StoreProductDetails from './StoreProductDetails'

export default StoreProductDetails